import { createBox } from '@material-ui/system';
import { createTheme } from '../styles';
const defaultTheme = createTheme();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme
});
export default Box;